import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext.tsx';
import { useSeoMeta } from '../hooks/useSeoMeta.ts';
import './css/NotFoundPage.css';

function NotFoundPage() {
  const { t, currentLanguage } = useTranslation();

  useSeoMeta({
    title: currentLanguage === 'ru' ? 'Страница не найдена — Sciplex' : 'Page not found — Sciplex',
    description:
      currentLanguage === 'ru'
        ? 'Запрашиваемая страница не существует или была перемещена.'
        : 'The requested page does not exist or has been moved.',
    noIndex: true,
  });

  return (
    <div className="not-found-wrap">
      <div className="not-found-card">
        <span className="not-found-code">404</span>
        <h1 className="not-found-title">{t('notFound.title')}</h1>
        <p className="not-found-description">{t('notFound.description')}</p>
        <Link to="/" className="not-found-button">
          {t('notFound.backHome')}
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
